<template lang="pug">
  .create-plan_rate-reservation-rates
    ModalReveal(ref="revealPlanEdit")
      button.button.success(slot="trigger" ) Edit
      .tabs-inner-content
        .row(v-if="plan_rate")
          .columns
            h2 Plan reservation rate
            .row
              .column
                label Name
                  input(type="text", v-model="plan_rate.name")
                label Vehicle Category
                  selectize-category(@optionSelected="selectCategory", :selectedValue="plan_rate.vehicle_category_id")


                label Reservation rate
                  selectize-reservation-rate(@optionSelected="selectRate", :selectedValue="plan_rate.reservation_rate_id")

                label Disabled
                  input(type="checkbox", v-model="plan_rate.disabled")
            .row
              .columns.text-right
                ActionButton(:action="savePlanRate") Save
</template>
<script type="text/babel">

import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
import PlanReservationRate from "../PlanReservationRate.vue";
import SelectizeCategory from "../../structure/ui/lists/selectize/SelectizeCategory";
import SelectizeReservationRate from "../../structure/ui/lists/selectize/SelectizeReservationRate";
import DatePicker from "../../structure/DatePicker";
import MaggieHelper from "../../../maggieHelper";
import BookingModeSelect from "../../structure/BookingModeSelect";
import ModalReveal from "../../structure/foundation/ModalReveal.vue";
import {EventBus} from "../../../eventBus";
import ActionButton from "../../structure/ui/ActionButton.vue";


export default {
  name: "EditPlanReservationRates",
  components: {
    ActionButton,
    ModalReveal,
    BookingModeSelect, DatePicker, SelectizeReservationRate, SelectizeCategory, PlanReservationRate
  },
  data() {
    return {
      plan_rate: null,
    }
  },
  created() {
    KeplerBackofficeSdk.planReservationRates.select(this.rateId).get((data) => {
      this.plan_rate = data
    })
  },
  methods: {
    selectCategory(item) {
      this.plan_rate.vehicle_category_id = item.id
    },
    selectRate(item) {
      this.plan_rate.reservation_rate_id = item.id
    },
    savePlanRate() {
      return KeplerBackofficeSdk.planReservationRates.select(this.rateId).edit(this.plan_rate, (data) => {
        MaggieHelper.notification('rate', 'Reservation rate edited')
        EventBus.$emit('reload-list')
        this.$refs.revealPlanEdit.close()
      })

    }
  },
  props: {
    rateId: {}
  },
  computed: {}
}
</script>
<style lang="sass" rel="stylesheet/sass">
.create-plan_rate-reservation-rates
  background: white

</style>



// WEBPACK FOOTER //
// EditPlanReservationRates.vue?65421f74